import { render, staticRenderFns } from "./RefLager.vue?vue&type=template&id=cecc48ba&scoped=true&"
import script from "./RefLager.vue?vue&type=script&lang=js&"
export * from "./RefLager.vue?vue&type=script&lang=js&"
import style0 from "./RefLager.vue?vue&type=style&index=0&id=cecc48ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecc48ba",
  null
  
)

export default component.exports